import styled from '@emotion/styled';
import { Warning as ErrorIconBase } from '@mui/icons-material';

const ErrorIcon = styled(ErrorIconBase)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export default ErrorIcon;
